export default String.raw`
<div class="message-popup-background container-to-delete-js">
	<div class="change-data-container inc">
		<div class="data-form__header">
			{{translations.MyData}}
			<button class="close-button cancel-js" data-template="partials/customer-profile/customer-details/customer-data.html" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
			</button>
		</div>
		<div class="form-js form-into-data-js edit-customer-data-js {% if customer.Company -%} external-base-js with-database-check-js {% if settings.editDataFromGUS == 'yes' -%} allow-edit-gus-js {% endif -%} {% if settings.editDataFromVIES == 'yes' -%} allow-edit-vies-js {% endif -%} {% endif -%}" data-include="customer-data" data-edit-data-from-gus="{{settings.editDataFromGUS}}" data-edit-data-from-vies="{{settings.editDataFromVIES}}">
			<input type="hidden" name="__action" value="Customer/Update" >
	  		<input type="hidden" name="company" value="{{ customer.Company }}">
			{% if customer.Address.Country != '' -%}
				{% assign country = customer.Address.Country -%}
			{% else -%}
				{% assign country = config.DefaultCountry -%}
			{% endif -%}
			{% capture inc -%}customer-data={{country}}{% endcapture -%}
			<div class="customer-data-edit-popup customer-data-address-js">
				{% include 'partials/common/address-form.html' with inc -%}
			</div>
			<div class="required-fields"><span class='required'>* </span>{{ translations.RequiredFields }}</div>
			<div class="buttons-container">
				<button class="pure-button download-GUS-data-js hidden-js" data-country="{{country}}" data-company="{{customer.Company}}">
					{{ translations.DownloadDataFromGUS }}
				</button>
				<button class="pure-button download-VIES-data-js hidden-js" data-country="{{country}}" data-company="{{customer.Company}}">
					{{ translations.DownloadDataFromVies }}
				</button>
				<button class="primary-action-button post-js replace-template-js container-reload-js close-js" data-template="partials/customer-profile/customer-details/customer-data.html">
					{{ translations.SaveChanges }}
				</button>
			</div>
		</div>
	</div>
</div>

{% include 'partials/customer-profile/customer-details/customer-data.html' -%}
`